var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopMenuBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0332 0.5C1.20478 0.5 0.533203 1.17157 0.533203 2C0.533203 2.82843 1.20478 3.5 2.0332 3.5V0.5ZM22.0332 3.5C22.8616 3.5 23.5332 2.82843 23.5332 2C23.5332 1.17157 22.8616 0.5 22.0332 0.5V3.5ZM2.0332 3.5H22.0332V0.5H2.0332V3.5Z",
    fill: "#FFFBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0332 9.0249C1.20478 9.0249 0.533203 9.69648 0.533203 10.5249C0.533203 11.3533 1.20478 12.0249 2.0332 12.0249V9.0249ZM22.0332 12.0249C22.8616 12.0249 23.5332 11.3533 23.5332 10.5249C23.5332 9.69648 22.8616 9.0249 22.0332 9.0249V12.0249ZM2.0332 12.0249H22.0332V9.0249H2.0332V12.0249Z",
    fill: "#FFFBEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0332 17.5483C1.20478 17.5483 0.533203 18.2199 0.533203 19.0483C0.533203 19.8768 1.20478 20.5483 2.0332 20.5483V17.5483ZM22.0332 20.5483C22.8616 20.5483 23.5332 19.8768 23.5332 19.0483C23.5332 18.2199 22.8616 17.5483 22.0332 17.5483V20.5483ZM2.0332 20.5483H22.0332V17.5483H2.0332V20.5483Z",
    fill: "#FFFBEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopMenuBar);
export default __webpack_public_path__ + "static/media/TopMenuBar.106699b3801193cb9299fc3ea3d467ac.svg";
export { ForwardRef as ReactComponent };